import { render, staticRenderFns } from "./index.vue?vue&type=template&id=605f022c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=605f022c&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=605f022c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f022c",
  null
  
)

export default component.exports